import { useState } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import Button from "../../../ui-lib/components/Button/Button";
import { RowData } from "../ObjectsTable";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import {
  AlarmHandling,
  batchFetchTemporaryHandling,
} from "../../../core/api/alarmhandlings";
import useUser from "../../../core/user/useUser";
import { notify } from "../../../ui-lib/components/Alerts/Toast";
import TemporaryAlarmHandlingModal from "../ObjectGeneral/TemporaryAlarmHandlingModal";

export const AssignTempAHBatch = ({
  items,
  onSuccess,
}: {
  items: RowData[];
  onSuccess: () => void;
}) => {
  const { authenticatedRequest } = useUser();
  const t = useTranslations();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alarmHandlings, setAlarmHandlings] = useState<AlarmHandling[]>([]);

  const userIds = items.map((i) => i.id);

  const openModal = async () => {
    setLoading(true);
    try {
      const res = await batchFetchTemporaryHandling(
        authenticatedRequest,
        userIds,
      );
      if (!res.data.length) {
        return notify({
          message: t("Objects:no_available_alam_handlings"),
          variant: "warning",
        });
      }
      setAlarmHandlings(res.data);
      setOpen(true);
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors, error.response?.status);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        text={`${t("Objects:change_selection")} (${items.length})`}
        onClick={() => openModal()}
        disabled={loading}
        loading={loading}
      />
      <TemporaryAlarmHandlingModal
        isOpen={open}
        setIsOpen={setOpen}
        alarmHandlings={alarmHandlings}
        userIds={userIds}
        onSuccess={onSuccess}
      />
    </>
  );
};
